import DirectoryTexts from "../classes/DirectoryTexts";

const state = {
  data: []
};

const getters = {};

const actions = {
  directory_texts_list(state, data) {
    state.commit("setData", data);
  }
};

const mutations = {
  setData(state, data) {
    state.data = DirectoryTexts.getSelfList(data);
  },
  addFirst(state) {
    state.data.unshift(new DirectoryTexts());
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
